<template>
  <div class="animated fadeIn">
    <div class="row col-md-12">
      <Forms
        class="col-md-9"
        ref="frmGroup"
        :title="'CADASTRO DE LISTA DE CONTATO'"
        :showClearButton="true"
        :showSaveButton="true"
        :showBackButton="true"
        :isModal="isModal"
        v-on:Clear="onClear"
        v-on:Back="onBack"
        v-on:Save="onSave"
      >
        <div class="form-group row">
          <div class="col-12">
            <label>
              <small
                v-show="form.nome.required"
                class="text-danger"
              >*</small> Lista:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o Nome da Lista'"
                v-model="form.nome.value"
                :size="form.nome.maxlength"
                :required="form.nome.required"
                :state="form.nome.state"
              ></b-form-input>
            </div>
          </div>
        </div>
      </Forms>

      <div
        class="d-flex flex-row flex-wrap col-md-3 side__bar"
        style="padding-right: 0"
      >
        <b-card id="side-menu" header="Ações" class="text-center w-100">
          <b-card-text>
            <b-button-group class="w-100" vertical>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openAcaoExportarExcel"
              >
                <i class="fas fa-file-export"></i> Exportar Excel
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openAcaoAbrirCardModal"
              >
                <i class="fas fa-plus"></i> Abrir Card
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openCreateCampanhaListaModal"
              >
               <i class="fas fa-list"></i> Criar Lista Campanha
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openSendWhatsAppListaModal"
              >
                <i class="fab fa-whatsapp"></i> Enviar WhatsApp
              </b-button>
              <b-button
                v-show="classeA"
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openSendSmsListaModal"
              >
                <i class="fas fa-sms"></i> Enviar SMS
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openSendEmailListaModal"
              >
                <i class="far fa-envelope"></i> Enviar E-mail
              </b-button>
            </b-button-group>
          </b-card-text>
        </b-card>
      </div>
    </div>

    <AcaoListaInteligenteGrid ref="AcaoListaInteligenteGrid" />

    <Tables
      ref="tableGrid"
      :columns="[
        'Num. Sisbr',
        'CPF/CNPJ',
        'Nome',
        'Agente Relacionamento',
        'Pa',
        'E-mail',
        'Celular',
        $lang.Common.DataTable.Actions
      ]"
      :showTipFooter="false"
      :showUpload="this.canAddContact"
      v-on:Upload="onOpenUpload"
      v-on:Load="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.numSisbr.toString()"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.documento"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.nome ? obj.nome.toUpperCase() : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.agenteRelacionamento ? obj.agenteRelacionamento.toUpperCase() : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.pa ? obj.pa.toString() : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.email ? obj.email : ''"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.celular ? obj.celular.toUpperCase() : ''"
        />
        <TableColumn
          :IsActionsButtons="true"
          :HasChange="false"
          v-on:Delete="onDeleteContact(obj)"
          :status="obj.status"
        />
      </tr>
    </Tables>

    <div class="row">
      <div class="col-md-12 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          :disabled="!canAddContact"
          @click="onOpenAdvancedContactAdd"
          v-b-tooltip.hover
          :title="'Adicionar Contatos de forma avançado na Lista'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none"> Adicionar Avançado</span>
        </button>
        <button
          v-if="this.objList && this.objList.length > 0"
          type="button"
          class="btn btn-danger btn-sm"
          :disabled="!canAddContact"
          @click="onDeleteContacts"
          v-b-tooltip.hover
          :title="'Limpar todos os contatos da lista'"
        >
          <i class="fas fa-user-minus"></i>
          <span class="d-md-down-none"> Limpar Contatos na Lista</span>
        </button>
      </div>
    </div>

    <ModalListaContatoAdvancedSearch ref="ModalListaContatoAdvancedSearch" @created="onLoad" />
    <OpenCardModal ref="OpenCardModal" @reloadAcoes="emitLoadAcoes" />
    <CreateCampanhaListaModal ref="CreateCampanhaListaModal" @reloadAcoes="emitLoadAcoes" />
    <SendEmailListaInteligenteModal ref="SendEmailListaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
    <SendSmsListaInteligenteModal ref="SendSmsListaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
    <SendWhatsappListaInteligenteModal ref="SendWhatsappListaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
    <SendExcelEmailConfirmationModal ref="SendExcelEmailConfirmationModal" @reloadAcoes="emitLoadAcoes" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import ListaContatoRepository from '@/shared/http/repositories/configurations/listacontato.js'
import ParametroClasseA from '@/shared/http/repositories/configurations/parametroClasseA'

import ModalListaContatoAdvancedSearch from '@/components/forms/ModalListaContatoAdvancedSearch.vue'
import AcaoListaInteligenteGrid from '@/views/private/configurations/lista-inteligente/components/add/grids/AcaoListaInteligenteGrid.vue'
import SendExcelEmailConfirmationModal from './modal/SendExcelEmailConfirmationModal.vue'
import OpenCardModal from './modal/OpenCardModal.vue'
import CreateCampanhaListaModal from './modal/CreateCampanhaListaModal.vue'
import SendEmailListaInteligenteModal from './modal/SendEmailListaInteligenteModal.vue'
import SendSmsListaInteligenteModal from './modal/SendSmsListaInteligenteModal.vue'
import SendWhatsappListaInteligenteModal from './modal/SendWhatsappListaInteligenteModal.vue'

const ListaInteligenteData = {
  id: null,
  nome: null
}

const ListaInteligenteForm = {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}

export default {
  name: 'ListaInteligenteAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: ListaInteligenteData,
      form: ListaInteligenteForm,
      canAddContact: false,
      classeA: true
    }
  },
  components: {
    AcaoListaInteligenteGrid,
    ModalListaContatoAdvancedSearch,
    SendExcelEmailConfirmationModal,
    OpenCardModal,
    CreateCampanhaListaModal,
    SendEmailListaInteligenteModal,
    SendSmsListaInteligenteModal,
    SendWhatsappListaInteligenteModal
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.canAddContact = false
      this.$refs.tableGrid.Clear()

      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onLoad () {
      this.hasClasseA()
      if (this.data && this.data.id) {
        loading.push()
        ListaContatoRepository.GetAllByListaInteligentePaging(this.data.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
        loading.pop()
      }
    },
    onDeleteContact (obj) {
      loading.push()
      ListaContatoRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      loading.push()
      if (obj && obj.id) {
        Tools.SetValueInForm(this.form, this.data, obj)
        this.canAddContact = true
        loading.push()

        this.$refs.AcaoListaInteligenteGrid.onLoadAcoes(obj.id)

        ListaContatoRepository.GetAllByListaInteligentePaging(obj.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
        loading.pop()
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      ListaInteligenteRepository.Create(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onEdit(response.data)
        })
        .catch(this.onException)
    },
    openAcaoExportarExcel () {
      this.$nextTick(() => {
        this.$refs['SendExcelEmailConfirmationModal'].openConfirmationModal(this.data.id)
      })
    },
    openAcaoAbrirCardModal () {
      this.$nextTick(() => {
        this.$refs['OpenCardModal'].showModal(this.data.id)
      })
    },
    openCreateCampanhaListaModal () {
      this.$nextTick(() => {
        this.$refs['CreateCampanhaListaModal'].showModal(this.data.id)
      })
    },
    openSendEmailListaModal () {
      this.$nextTick(() => {
        this.$refs['SendEmailListaInteligenteModal'].showModal(this.data.id)
      })
    },
    openSendSmsListaModal () {
      this.$nextTick(() => {
        this.$refs['SendSmsListaInteligenteModal'].showModal(this.data.id)
      })
    },
    openSendWhatsAppListaModal () {
      this.$nextTick(() => {
        this.$refs['SendWhatsappListaInteligenteModal'].showModal(this.data.id)
      })
    },
    emitLoadAcoes () {
      this.$refs.AcaoListaInteligenteGrid.onLoadAcoes(this.data.id)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      ListaInteligenteRepository.Update(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onDeleteContacts () {
      loading.push()
      ListaInteligenteRepository.DeleteList(this.data.id)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onOpenContactAdd () {
      this.$refs.ModalListaContatoAdvancedSearch.showModal(this.data.id)
    },
    onOpenAdvancedContactAdd () {
      this.$refs.ModalListaContatoAdvancedSearch.showModal(this.data.id)
    },
    onOpenUpload () {
      this.$refs.ModalListaContatoAdvancedSearch.showModal(this.data.id)
    },
    hasClasseA () {
      ParametroClasseA.GetAll()
        .then(response => {
          if (!response.data || !response.data.usuario) {
            this.classeA = false
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
#side-menu {
  height: fit-content;

  .card-header {
    color: white;
    background: linear-gradient(90deg, #2dce89, #2dcecc);
  }

  .card-body {
    height: fit-content;
  }
}

.btn.side-menu__links.btn-outline-primary {
  border: 1px solid #cfd8dc;
  color: #04a791;
  text-align: left;

  &:hover {
    background: #04a791;
    color: white;
  }
}

.side__bar {
  @media screen and (max-width:900px) {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/ListaInteligenteAdd.vue